import { render, staticRenderFns } from "./AccountingNotes.vue?vue&type=template&id=3d6fd0de&lang=pug&"
import script from "./AccountingNotes.vue?vue&type=script&lang=js&"
export * from "./AccountingNotes.vue?vue&type=script&lang=js&"
import style0 from "./AccountingNotes.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "AccountingNotes.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
installComponents(component, {
  VCard,
})
